import { Collapse } from 'antd';

export default function CustomCollapse(props) {
	return <Collapse {...props} />;
}
